import { useCallback, useState, type JSX } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import { useAuth, useAuthIsAnonymous } from '@footsteps/shared';
import { Section } from './Section';
import { RegisterUser } from './register-user';
import { styles } from './header.styles';

export const Header = (): JSX.Element => {
  const { signOut } = useAuth();
  const isAnonymous = useAuthIsAnonymous();
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const isVerified = !isAnonymous;

  const handleVerifySuccess = useCallback(() => {
    setIsLoginOpen(false);
  }, []);

  return (
    <Section paddingY='small'>
      <header className='header'>
        <div className='header-content'>
          <img src='/images/chatbot-avatar-512.png' alt='WOZ Taxateur' className='header-avatar' />
          <h1>WOZ Bezwaarhulp</h1>
          <div className='header-actions'>
            {isVerified ? (
              <>
                <Button variant='outlined' size='small' startIcon={<LockIcon />} onClick={signOut}>
                  Uitloggen
                </Button>
              </>
            ) : (
              <Button variant='outlined' size='small' startIcon={<LockOpenIcon />} onClick={() => setIsLoginOpen(true)}>
                Inloggen
              </Button>
            )}
          </div>
        </div>
      </header>

      <Dialog
        open={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        maxWidth='sm'
        fullWidth
        slotProps={{ paper: { sx: styles.dialogPaper } }}
      >
        <DialogTitle sx={styles.dialogTitle}>
          Inloggen
          <IconButton
            aria-label='sluiten'
            onClick={() => setIsLoginOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={styles.dialogContent}>
          <RegisterUser showLogin onVerifySuccess={handleVerifySuccess} />
        </DialogContent>
      </Dialog>
    </Section>
  );
};
